import Vue from 'vue'
// svg组件
import SvgIcon from '../../common/utils/components/svg-icon/index'

// register globally
Vue.component('svg-icon', SvgIcon)

// require.context函数接受三个参数
//
// directory {String} -读取文件的路径
//
// useSubdirectories {Boolean} -是否遍历文件的子目录
//
// regExp {RegExp} -匹配文件的正则
const req = require.context('./svg', true, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)



// WEBPACK FOOTER //
// ./src/static/icons/index.js